// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueFlexboxgrid from 'vue-flexboxgrid'
import VueHead from 'vue-head'
import 'vue-flexboxgrid/dist/vue-flexboxgrid.css'
import 'es6-promise/auto'
import { store } from './store.js'
import VueTinyLazyloadImg from 'vue-tiny-lazyload-img'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

Vue.config.productionTip = false
Vue.use(VueHead)
Vue.use(VueFlexboxgrid)
Vue.use(VueTinyLazyloadImg)
Vue.component('multiselect', Multiselect)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  components: { App },
  template: '<App/>',
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function () {
      return {
        inner: 'Fortnite Emotes',
        complement: 'Videos of All Fortnite Emotes'
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js